module.exports = __webpack_public_path__ + "static/whitedinosaur-faf36e4d502958c164628076682e7711.png";